module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-600.a01d8d834b68e27dba4e.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.eot
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.eot
// module chunks = styles